import type { SVGProps } from "react";

export type FlameLogoProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

/** Transparent flame mark — lavender fill, brand purple stroke */
export function FlameLogo({ size = 32, className = "", ...props }: FlameLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      width={size}
      height={size}
      className={`shrink-0 ${className}`}
      role="img"
      aria-hidden={props["aria-label"] ? undefined : true}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDE9FE"
        stroke="#A78BFA"
        strokeWidth="3.5"
        strokeLinejoin="round"
        d="M50 8
           C54 18 62 24 60 34
           C68 30 72 40 68 50
           C76 46 78 58 70 66
           C82 62 80 76 68 84
           C58 92 50 94 42 84
           C30 76 28 62 38 66
           C32 58 34 46 42 50
           C38 40 42 30 50 34
           C48 24 46 18 50 8
           Z
           M50 56
           C46 62 46 70 50 76
           C54 70 54 62 50 56
           Z"
      />
    </svg>
  );
}
